var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42530_32075",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 21.8,
    height: 21.8,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42530_32075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68366 5.5V5.4H4.58366H3.76699V3.76667H8.25033H8.35033V3.66667V2.85H13.6503V3.66667V3.76667H13.7503H18.2337V5.4H17.417H17.317V5.5V17.4167C17.317 17.8941 17.1482 18.3003 16.8077 18.6407C16.4673 18.9812 16.0611 19.15 15.5837 19.15H6.41699C5.93956 19.15 5.53333 18.9812 5.19291 18.6407C4.85249 18.3003 4.68366 17.8941 4.68366 17.4167V5.5ZM15.6837 5.5V5.4H15.5837H6.41699H6.31699V5.5V17.4167V17.5167H6.41699H15.5837H15.6837V17.4167V5.5ZM9.98366 7.43333V15.4833H8.35033V7.43333H9.98366ZM13.6503 7.43333V15.4833H12.017V7.43333H13.6503Z",
    fill: "#1C1D2D",
    stroke: "white",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon1);
export default __webpack_public_path__ + "static/media/deleteIcon_1.9ab8100c427baad86b9e703ac6f3021e.svg";
export { ForwardRef as ReactComponent };